import { fromPromise } from 'rxjs/observable/fromPromise';
import { Config } from './../../config/config';
var algoliasearch = require('algoliasearch');
var AlgoliaService = (function () {
    function AlgoliaService() {
        this.client = algoliasearch(Config.getEnvironmentVariable("algolia_app"), Config.getEnvironmentVariable("algolia_key"));
    }
    AlgoliaService.prototype.search = function (string, index, params) {
        if (!this.index)
            this.index = this.client.initIndex(index);
        return fromPromise(this.index.search(string, params));
    };
    return AlgoliaService;
}());
export { AlgoliaService };
export function provideAlgoliaService() {
    return new AlgoliaService();
}
//# sourceMappingURL=algolia.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/algolia/algolia.service.js
// module id = 184
// module chunks = 0